import React, { useState, useEffect } from 'react';

const WarningModal = ({ t, showModal, message }) => {
    const [timeLeft, setTimeLeft] = useState(null);
    let [count, setCount] = useState(0);

    useEffect(() => {
        if(count === 0){
            setTimeLeft(5)
        }
        setCount(++count);
        if(timeLeft === 0){
           if (!timeLeft) return;
           setTimeLeft(null)
        }
        const intervalId = setInterval(() => {
          setTimeLeft(timeLeft - 1);
        }, 1000);
        return () => clearInterval(intervalId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeLeft]);

    return(
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("jobsManagement.infoJob.warningModal.title")}</h5>
                        </div>
                        <div className="modal-body">
                            <b>{message}</b>
                            <div className='d-flex flex-column align-items-center'> <div style={{width: '25px', 
                                height: '25px', overflow:'hidden', display:'block', float:'left', position: 'relative',
                                borderRadius:'50%', MozBorderRadius:'50%', WebkitBorderRadius:'50%', KhtmlBorderRadius: '50%',
                                border: '4px solid', borderTop:'10px solid transparent', zIndex: '9', padding:'40px'
                            }}>
                                <span style={{color: 'black', position: 'absolute', top: '5%', left: '15%'}}>Auto retry</span>
                                <span style={{color: 'black', position: 'absolute', top: '22%', left: '45%'}}>in..</span>
                                <span style={{color: 'black', position: 'absolute', top: '40%', left: '45%'}}><h4>{timeLeft}</h4></span>
                            </div></div>
                            
                        </div>                    
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default WarningModal;